/**
 * Segments d'URL racine qui ne correspondent pas à un slug de musée.
 */
export const RESERVED_ROOT_PATHS = ['login', 'qr-code'] as const;

export const isReservedRootPath = (segment: string): boolean =>
  (RESERVED_ROOT_PATHS as readonly string[]).includes(segment);

/**
 * Extrait le slug du musée depuis l'URL
 * Exemple: admin.oratorio.com/musee-du-nouveau-monde -> musee-du-nouveau-monde
 */
export const getMuseumSlugFromUrl = (): string | null => {
  const pathname = window.location.pathname;

  const pathParts = pathname.split('/').filter(Boolean);
  if (pathParts[0] && !isReservedRootPath(pathParts[0])) {
    return pathParts[0];
  }

  return null;
};

/**
 * Valide le format d'un slug de musée
 */
export const isValidMuseumSlug = (slug: string): boolean => {
  return /^[a-z0-9-]+$/.test(slug) && slug.length > 0;
};

/**
 * Extrait le slug du musée depuis l’email (format museumSlug#email@domain.com).
 */
export const getMuseumSlugFromEmail = (email: string | null | undefined): string => {
  if (!email) return '';
  const part = email.split('#')[0];
  return part ?? '';
};

